import React from "react";
import "./CompaniesLogo.css";

import C1 from "../../../assets/companies/c1.webp";
import C2 from "../../../assets/companies/c2.webp";
import C3 from "../../../assets/companies/c3.webp";
import C4 from "../../../assets/companies/c4.webp";
import C5 from "../../../assets/companies/c5.webp";
import C6 from "../../../assets/companies/c6.webp";
import C7 from "../../../assets/companies/c7.webp";
import C8 from "../../../assets/companies/c8.webp";
import C9 from "../../../assets/companies/c9.webp";
import C10 from "../../../assets/companies/c10.webp";
import C11 from "../../../assets/companies/c11.webp";
import C12 from "../../../assets/companies/c12.webp";
import C13 from "../../../assets/companies/c13.webp";
import C14 from "../../../assets/companies/c14.webp";
import C15 from "../../../assets/companies/c15.webp";
import C16 from "../../../assets/companies/c16.webp";


const logos = [C1, C2, C3, C4, C5, C6, C7, C8, C9, C10, C11, C12, C13, C14, C15, C16];

const CompaniesLogo = () => {
  return (
    <div className="logo-slider-wrapper">
  <h2 className="faq-title">Our Partners</h2>
      <div className="logo-slider-track">
        {[...logos, ...logos].map((logo, index) => (
          <div className="logo-slide" key={index}>
            <img src={logo} alt="Company Logo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompaniesLogo;
